import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import type { DetailedFollowUpTicket } from 'src/types/followUp';

interface RespondentBioSectionProps {
  respondent: DetailedFollowUpTicket['respondent'];
}

const RespondentBio: FC<RespondentBioSectionProps> = ({ respondent }) => {
  const { t } = useTranslation('followUp');

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="body3">{t('respondent')}</Typography>
      <Typography sx={(theme) => ({ color: theme.colors.neutral[600] })}>
        {respondent?.name || t('changelog.deletedUser')}
      </Typography>
      <Typography
        variant="body4"
        sx={(theme) => ({ color: theme.colors.neutral[600] })}
      >
        {respondent?.orgUnit[respondent?.orgUnit.length - 1]}
      </Typography>
      <Typography
        variant="body4"
        sx={(theme) => ({ color: theme.colors.neutral[600] })}
      >
        {respondent?.email}
      </Typography>
      {respondent?.phone && (
        <Typography
          variant="body4"
          sx={(theme) => ({ color: theme.colors.neutral[600] })}
        >
          {respondent?.phone}
        </Typography>
      )}
    </Box>
  );
};

export default RespondentBio;
